const Measurement = require('graph-netecs/js/Measurement').Measurement;
const Constants = require('graph-netecs/js/Constants').Constants;

const fanSummary = require('./fanSummary').fanSummary;
const fanGraphs = require('./fanGraphs').fanGraphs;
const measurementsAbstract = require('./measurementsAbstract').measurementsAbstract;

import {fanObjParamsManager} from "./fanObjParamsManager";

const Events = (() => {
    const cache = new Map

    const observer = new MutationObserver(function(mutations) {
        for (let mutation of mutations) {
            if (mutation.type === 'childList') {
                if (mutation.removedNodes.length) {
                    console.log('element removed from the dom, removing all events for the element')
                    mutation.removedNodes.forEach(x => Events.remove(x))
                }
            }
        }
    })

    // watch the dom for the element being deleted
    observer.observe(document.body, { childList: true })

    return {

        add(el, type, fn, capture = false) {
            let cached = cache.get(el)
            if (!cached) {
                cached = {}
                cache.set(el, cached)
            }
            if (!cached[type]) {
                cached[type] = new Set
            }
            cached[type].add(fn)
            el.addEventListener(type, fn, capture)
        },

        remove(el, type, fn) {
            const cached = cache.get(el)
            if (!cached) {
                return false
            }
            // remove all events for an event type
            if (type && !fn) {
                cached[type].forEach(fn => {
                    el.removeEventListener(type, fn)
                })
                cached[type] = new Set
            }
            // remove a specific event
            else if (type && fn) {
                el.removeEventListener(type, fn)
                // remove the event from the cache
                cached[type].delete(fn)
            }
            // remove all events for the element
            else {
                for (let key in cached) {
                    cached[key].forEach(fn => {
                        el.removeEventListener(key, fn)
                    })
                }
                cache.delete(el)
            }
        },

        show(el, type) {
            const cached = cache.get(el)
            if (!cached) {
                return false
            }
            if (type) {
                return cached[type]
            }
            return cached
        }
    }
})()


class Calculator {
    static calculate(store) {
        return new Promise(resolve => {
            if (store && store.state && store.state.activeFun && store.state.activeFun.count) {
                store.state.activeFun.count = 1;
            }

            let data = this.getParamsData(store);
            let timeoutsIDs = [];
            let intervalID = null;
            let currentTitle = document.title;

            this.popFansTable(store);

            let maxCount = store.state.fansOfPath.length; //Five minutes
            let doneFans = 0;

            const incrementDoneFans = () => {
                doneFans++;
            };

            for (let grap in window.measurementShow.graphsObj.graphs) {
                let plane =  window.measurementShow.graphsObj.graphs[grap].graph;
                Events.remove(plane._svg);
                plane._svg = null;

                for(let i = plane._xs.length - 1; i >= 0; i--){
                    let axis = plane._xs[i];
                    Events.remove(axis._svg);
                    axis._svg = null;
                    plane.removeAxis(axis)
                }

                for(let i = plane._ys.length - 1; i >= 0; i--){
                    let axis = plane._ys[i];
                    Events.remove(axis._svg);
                    axis._svg = null;
                    plane.removeAxis(axis)
                }

                for (let point of window.measurementShow.graphsObj.graphs[grap].points) {
                    window.measurementShow.graphsObj.graphs[grap].removeAll();
                }
            }


            const resolveCalculations = () => {
                if (store.state.fansTableData.fans_table.length > 0) {
                    store.commit({
                        type: 'selectFanRowAsActiveInFansTable',
                        fan_id: store.state.fansTableData.fans_table[0].id
                    });
                }

                resolve();
            }

            if (store.state.fansOfPath.length > 0) {
                this.chechNextFan(store.state.fansOfPath, 0, incrementDoneFans, store, data, timeoutsIDs);
            }

            const checkIfDone = () => {

                let percentage = Math.round(doneFans * 100 / (maxCount - 1));
                store.state.calculatingPercentage = percentage;
                document.title = percentage + "%";

                if (doneFans == maxCount || maxCount == 0) {
                    document.title = currentTitle;
                    resolveCalculations();

                    for (let timeoutID of timeoutsIDs) {
                        clearTimeout(timeoutID);
                    }
                    timeoutsIDs = [];

                    clearInterval(intervalID);
                }
            }

            intervalID = setInterval(checkIfDone, 80);
        });
    }

    static getParamsData(store) {
        let pressureType = fanObjParamsManager.getPressureType(store);
        let pressureTypeCapitalized = pressureType.charAt(0).toUpperCase() + pressureType.slice(1);
        let frequency = fanObjParamsManager.getNetwork_frequency(store);
        let extensionInfo = this.getExtensionInfo(store);
        let fanPositionFilter = this.getFanPositionFilter(store);
        let performance = store.state.fourthStepParametersSelected.performance.value;
        // NVS-102
        //let desiredTemperature = store.state.fourthStepParametersSelected.temperature.value - 273.15;

        let fansOfSelectedAtex = store.state.relationsFanAtexes.filter(x => x.id == extensionInfo.id);
        let fansOfStandardAtex = store.state.relationsFanAtexes.filter(x => x.id == 0);

        let currentPhase = fanObjParamsManager.GetSelectedElementOfOption(store.state.fourthStepParametersSelected.electricity.options.current_phase.elements);
        let currentType = fanObjParamsManager.GetSelectedElementOfOption(store.state.fourthStepParametersSelected.electricity.options.current_type.elements);

        let firstStepFilteredEngines = store.state.enginesList.filter((element) => {
            return this.enginesFilter(currentType, currentPhase, element, store) // NVS-102 desiredTemperature, store)
        });

        if (frequency == 50) {
            firstStepFilteredEngines = firstStepFilteredEngines.sort(function (a, b) {
                return a.power_50_hz - b.power_50_hz;
            });
        } else {
            firstStepFilteredEngines = firstStepFilteredEngines.sort(function (a, b) {
                return a.power_60_hz - b.power_60_hz;
            });
        }

        return {
            "fansOfSelectedAtex": fansOfSelectedAtex,
            "fansOfStandardAtex": fansOfStandardAtex,
            "fanPositionFilter": fanPositionFilter,
            "frequency": frequency,
            "pressureTypeCapitalized": pressureTypeCapitalized,
            "pressureType": pressureType,
            "performance": performance,
            "extensionInfo": extensionInfo,
            "firstStepFilteredEngines": firstStepFilteredEngines,
        };
    }

    static getDefaultManufacturerByTemperature(temperature, store) {
        let ranges = store.state.engineTemperatureRanges;

        let manufacturer = '';

        for(let range of ranges) {
            if(range['range_from'] && range['range_to'] && range['manufacturer']) {
                let rangeFrom = parseFloat(range['range_from']);
                let rangeTo = parseFloat(range['range_to']);
                temperature = parseFloat(temperature);

                if(rangeFrom <= temperature && temperature <= rangeTo) {
                    manufacturer = range['manufacturer'];
                    break;
                }
            }
        }

        return manufacturer;
    }

    // NVS-57 Metoda zwraca klasę sprawności silnika wg mocy
    static getEfficiencyClassByPower(power, store) {
        if (store.state && store.state.engineEfficiencyRanges) {
            let ranges = store.state.engineEfficiencyRanges;

            for(let range of ranges) {
                if(range['range_from'] && range['range_to'] && range['efficiency_class']) {
                    const rangeFrom = parseFloat(range['range_from']);
                    const rangeTo = parseFloat(range['range_to']);
                    power = parseFloat(power);

                    if(rangeFrom <= power && power <= rangeTo) {
                        return range['efficiency_class'];
                    }
                }
            }
        }
    }

    static chechNextFan(fans, indexOfFan, incrementDoneFans, store, data, timeoutsIDs) {
        let timeoutID = setTimeout(async () => {
            let startTime = Date.now();
            let fan = fans[indexOfFan];

            let temperatureParamActive = store.state.fourthStepParametersSelected.temperature.active;
            let desiredTemperature = store.state.fourthStepParametersSelected.temperature.value;
            let minTemperature = fan.medium_temperature_from;
            let maxTemperature = fan.medium_temperature_to;

            let fanSpecialVersion = fan.special_version_60hz;

            let continueLoop1 = false;
            let engine_rpm = null;

            let fanInAtexex = data.fansOfSelectedAtex.find(x => x.fan_id == fan.id);
            let fanStandardInAtex = data.fansOfStandardAtex.find(x => x.fan_id == fan.id);

            if (!fanInAtexex)
                continueLoop1 = true;

            if (!this.validate_electricity(fan, store))
                continueLoop1 = true;

            if (!this.validateFilterLocation(data.fanPositionFilter, fan))
                continueLoop1 = true;

            if (fan.operating_range_to_50_hz == "0" && parseInt(data.frequency) == 50)
                continueLoop1 = true;

            if (temperatureParamActive) {
                minTemperature = parseInt(minTemperature) + 273.15;
                maxTemperature = parseInt(maxTemperature) + 273.15;

                if (desiredTemperature > maxTemperature || desiredTemperature < minTemperature) continueLoop1 = true;
            }

            let operating_range_from_50_hz = fan.operating_range_from_50_hz;

            let max_frequency = parseFloat(fan.max_frequency);

            if (parseFloat(fan.max_speed) > 0 && store.state.appMeasurementsList[fan['id_measurement']] && store.state.appMeasurementsList[fan['id_measurement']].hasOwnProperty("engine_rpm")) {
                engine_rpm = parseFloat(store.state.appMeasurementsList[fan['id_measurement']]["engine_rpm"]);
            }

            if (operating_range_from_50_hz == 0 && parseInt(data.frequency) == 60)
                continueLoop1 = true;

            let workOnInverter = store.state.fourthStepParametersSelected.work_on_the_inverter.options[0].elements[0];
            let workingOnInverter = false;

            switch (workOnInverter.value) {
                case "no":
                    if (workOnInverter.active)
                        workingOnInverter = false;
                    else
                        workingOnInverter = true;
                    break;
                case "yes":
                    if (workOnInverter.active)
                        workingOnInverter = true;
                    else
                        workingOnInverter = false;
                    break;
            }

            let workPointFreequency = 0;

            if (!workingOnInverter)
                workPointFreequency = parseFloat(data.frequency);

            if (!workingOnInverter && workPointFreequency > max_frequency)
                continueLoop1 = true;

            let specialVersionValid = false;

            if (fanSpecialVersion === '1') {
                if(!workingOnInverter && parseInt(data.frequency) === 50) {
                    continueLoop1 = true;
                } else {
                    specialVersionValid = true;
                }
            }

            if (continueLoop1 == false && store.state.appMeasurementsList[fan['id_measurement']] && store.state.appMeasurementsList[fan['id_measurement']].hasOwnProperty("characteristic")) {
                let number_of_fans = 1;
                let bestFanOfFrequency = [];
                let frequencyList = [];
                let frequencyTmp = data.frequency;
                let performanceTmp = data.performance;
                let performanceHourTmp = performanceTmp * 3600;
                let continueLooping = true;
                let countOfSearching = 0;
                let approximate_frequency_value = null;
                let nextFrequencyStep = 0;

                let bestFan = null;
                let actualMinDelta = null;
                let requestedPressureUnitValue = null;
                while (continueLooping) {
                    if (countOfSearching == 0) {//Pierwsze szukanie
                        frequencyTmp = parseFloat(data.frequency);
                    } else if (countOfSearching == 1 && store.state.selectedSecondStepElement.multiple_fans != 1) { //Drugie szukanie
                        if (!bestFanOfFrequency[0] || !bestFanOfFrequency[0].measurement) {
                            continueLooping = false;
                            continue;
                        }

                        approximate_frequency_value = Math.pow(((parseFloat(store.state.fourthStepParametersSelected.pressure.value * Math.pow(data.frequency, 3)) / bestFanOfFrequency[0].measurement.graphsObj.workPointResult[data.pressureTypeCapitalized + "Pressure"])), 1.0 / 3.0);
                        approximate_frequency_value = Math.round(approximate_frequency_value);

                        if ((approximate_frequency_value - 2) > max_frequency || (approximate_frequency_value + 2) < fan.min_frequency) { // sprawdzanie +/- 2 Hz, żeby wyeliminować aptekę
                            continueLooping = false;
                            continue;
                        }

                        if (approximate_frequency_value > max_frequency) {// Jeżeli przeszło po wyeliminowaniu apteki, to trzeba mieć pewność, że nie wykraczamy po za zakres jednocześnie mieszcząc się w przedziale +/- 2 Hz
                            approximate_frequency_value = max_frequency;
                        }
                        if (approximate_frequency_value < fan.min_frequency) {
                            approximate_frequency_value = fan.min_frequency;
                        }

                        if (approximate_frequency_value > data.frequency) {
                            nextFrequencyStep = 1;
                        } else if (approximate_frequency_value < data.frequency) {
                            nextFrequencyStep = -1;
                        }


                        frequencyTmp = approximate_frequency_value;

                        requestedPressureUnitValue = {
                            _oryginal: store.state.fourthStepParametersSelected.pressure.value,
                            _unit: bestFanOfFrequency[0].measurement.graphsObj.workPointResult[data.pressureTypeCapitalized + "Pressure"]._unit
                        };

                        let comparationResult = this.compareAndFindBestFan(requestedPressureUnitValue, bestFanOfFrequency[0], actualMinDelta, data.pressureTypeCapitalized);

                        if (comparationResult) {
                            bestFan = comparationResult.fan;
                            bestFan.fan.data['maximum_engine_power'] = bestFanOfFrequency[0].maximum_engine_power;
                            bestFan.fan.params['engine_efficiency'] = bestFanOfFrequency[0].engine_efficiency;
                            bestFan.fan.engine = bestFanOfFrequency[0].engine;

                            actualMinDelta = comparationResult.actualMinDelta;
                        }

                    } else if (countOfSearching > 1 && store.state.selectedSecondStepElement.multiple_fans != 1) { // Trzecie szukanie
                        if (frequencyList[frequencyList.length - 1] >= parseFloat(fan.min_frequency) && frequencyList[frequencyList.length - 1] <= max_frequency) {
                            let comparationResult = this.compareAndFindBestFan(requestedPressureUnitValue, bestFanOfFrequency[bestFanOfFrequency.length - 1], actualMinDelta, data.pressureTypeCapitalized);

                            if (comparationResult) {
                                bestFan = comparationResult.fan;
                                bestFan.fan.data['maximum_engine_power'] = bestFanOfFrequency[bestFanOfFrequency.length - 1].maximum_engine_power;
                                bestFan.fan.params['engine_efficiency'] = bestFanOfFrequency[bestFanOfFrequency.length - 1].engine_efficiency;
                                bestFan.fan.engine = bestFanOfFrequency[bestFanOfFrequency.length - 1].engine;

                                actualMinDelta = comparationResult.actualMinDelta;
                            } else {
                                continueLooping = false;
                            }
                        } else {
                            continueLooping = false;
                        }

                        frequencyTmp = frequencyTmp + nextFrequencyStep;
                    }

                    if (store.state.selectedSecondStepElement.multiple_fans == 1) {
                        if (countOfSearching > 29) continueLooping = false;

                        if (bestFanOfFrequency.length > 0) {
                            requestedPressureUnitValue = {
                                _oryginal: store.state.fourthStepParametersSelected.pressure.value,
                                _unit: bestFanOfFrequency[0].measurement.graphsObj.workPointResult[data.pressureTypeCapitalized + "Pressure"]._unit
                            };

                            let currentFan = bestFanOfFrequency[bestFanOfFrequency.length - 1];

                            if (!actualMinDelta || actualMinDelta > Math.abs(currentFan.measurement.graphsObj.workPointResult[data.pressureTypeCapitalized + "Pressure"]._oryginal - requestedPressureUnitValue._oryginal)) {
                                actualMinDelta = Math.abs(currentFan.measurement.graphsObj.workPointResult[data.pressureTypeCapitalized + "Pressure"]._oryginal - requestedPressureUnitValue._oryginal);
                                currentFan.fan.data['number_of_fans'] = countOfSearching;
                                currentFan.fan.params['number_of_fans'] = countOfSearching;
                                bestFan = currentFan;
                            } else if (actualMinDelta && actualMinDelta < Math.abs(currentFan.measurement.graphsObj.workPointResult[data.pressureTypeCapitalized + "Pressure"]._oryginal - requestedPressureUnitValue._oryginal)) {
                                continueLooping = false;
                            }
                        }
                    } else {
                        if (bestFan && bestFan.fan && bestFan.fan.data) {
                            bestFan.fan.data['number_of_fans'] = 1;
                            bestFan.fan.params['number_of_fans'] = 1;
                        }
                    }

                    if (!continueLooping) {
                        if (bestFan) {
                            bestFan.fan.engine = bestFan.engine;

                            for (let param in store.state.fansTableData.params_table) {
                                if (store.state.fansTableData.params_table.hasOwnProperty(param)) {
                                    fanObjParamsManager.fillParam(fan, store, bestFan.measurement, param, bestFan.fan, data.extensionInfo, bestFan.fan.data.number_of_fans);
                                    // if (!this.validateParam(fan, store, bestFan.measurement, param, bestFan.fan, data.extensionInfo, bestFan.fan.data.number_of_fans)) {
                                    //     fanIsValid = false;
                                    //     break;
                                    // }
                                }
                            }
                            // NVS-44 Wzrost temperatury obliczamy niezależnie czy jest aktywny w tabeli wyników czy nie, ponieważ może być też aktywny w punkcie pracy, a wtedy jest potrzebny do ukrywania cen w tabeli wyników
                            fanObjParamsManager.fillParam(fan, store, bestFan.measurement, 'fan_temperature_increase', bestFan.fan, data.extensionInfo, bestFan.fan.data.number_of_fans)
                            if(specialVersionValid) {
                                if(parseFloat(data.frequency) === 60) {
                                    this.addFanToResultTable(bestFan.fan, store);
                                } else {
                                    if(bestFan.fan.data.network_frequency > 50) {
                                        this.addFanToResultTable(bestFan.fan, store);
                                    }
                                }
                            } else {
                                this.addFanToResultTable(bestFan.fan, store);
                            }
                        }

                        bestFan = null;
                        continue;
                    }

                    frequencyList.push(frequencyTmp);
                    countOfSearching++;

                    if (store.state.selectedSecondStepElement.multiple_fans == 1 && countOfSearching > 0) {
                        performanceTmp = data.performance / (countOfSearching);
                        number_of_fans = countOfSearching;
                    }

                    performanceHourTmp = performanceTmp * 3600;


                    let measurementTmp = this.MakeMeasurement(store, fan['id_measurement'], frequencyTmp, data.pressureType, performanceTmp, performanceHourTmp);
                    
                    let fanObj = {
                        id: fan.id,
                        imgSrc: store.state.appFansImagesList[fan.id_app_fan_image].image,
                        isActive: false,
                        isCompared: false,
                        model: fan.name,
                        type: store.state.FansTypesList[fan.id_type].name,
                        suctionConnection: {}, //conn
                        pressingConnection: {}, //conn
                        data: store.state.appMeasurementsList[fan['id_measurement']],
                        engine: null,
                        params: {}
                    };

                    /*
                        NVS-3 OBIEKTY:
                        suctionConnection {diameter, norm, src}
                        pressingConnection {outlet, diameter, outlet_a, outlet_b, norm, src}
                    */

                    if(fan['suction_connection'] !== 'none') {
                        // NVS-122
                        let connection_id = null;
                        if(fan['suction_connection'] !== 'auto') connection_id = fan['id_suction_connection'];
                        else connection_id = store.state.appMeasurementsList[fan['id_measurement']].connection_id;

                        // NVS-163
                        if (store.state.ConnectionsList[connection_id] != undefined) {

                            //ustawiam parametry przyłącza na ssaniu
                            fanObj.suctionConnection['diameter'] = store.state.ConnectionsList[connection_id].outlet_diameter;
                            fanObj.suctionConnection['norm'] = store.state.ConnectionsList[connection_id].norm;
                            fanObj.suctionConnection['image'] = store.state.ConnectionsList[connection_id].image;
                            fanObj.suctionConnection['title'] = 'suction_connection'

                        }
                        
                        // szukam przyłącza po parametrach
                        let searchedConnection = null;
                        Object.values(store.state.ConnectionsList).forEach(connection => {
                            searchedConnection = (
                                (
                                    connection.is_standard == 1 &&
                                    connection.outlet == 'circle' &&
                                    connection.outlet == store.state.appMeasurementsList[fan['id_measurement']].outlet && 
                                    connection.outlet_diameter != 0 && 
                                    connection.outlet_diameter == store.state.appMeasurementsList[fan['id_measurement']].outlet_diameter
                                )
                                || 
                                (
                                    connection.is_standard == 1 &&
                                    connection.outlet == 'rectangle' &&
                                    connection.outlet == store.state.appMeasurementsList[fan['id_measurement']].outlet &&
                                    connection.outlet_a != 0 &&
                                    connection.outlet_b != 0 &&
                                    connection.outlet_a == store.state.appMeasurementsList[fan['id_measurement']].outlet_a &&
                                    connection.outlet_b == store.state.appMeasurementsList[fan['id_measurement']].outlet_b
                                )
                            ) ? connection : null;
                            if(searchedConnection && searchedConnection.image && searchedConnection.norm && fan['suction_connection'] != 'special') {
                                fanObj.pressingConnection['image'] = searchedConnection.image;
                                fanObj.pressingConnection['norm'] = searchedConnection.norm;
                                return;
                            }
                        })

                        // ustawiam parametry przyłacza na tłoczeniu
                        fanObj.pressingConnection['outlet'] = (fan['suction_connection'] != 'special') ? store.state.appMeasurementsList[fan['id_measurement']].outlet : store.state.ConnectionsList[fan['id_pressing_connection']].outlet;
                        fanObj.pressingConnection['diameter'] = (fan['suction_connection'] != 'special') ? (store.state.appMeasurementsList[fan['id_measurement']].outlet == 'circle' ? store.state.appMeasurementsList[fan['id_measurement']].outlet_diameter : 0) : store.state.ConnectionsList[fan['id_pressing_connection']].outlet_diameter;
                        fanObj.pressingConnection['outlet_a'] = (fan['suction_connection'] != 'special') ? (store.state.appMeasurementsList[fan['id_measurement']].outlet == 'rectangle' ? store.state.appMeasurementsList[fan['id_measurement']].outlet_a : 0) : store.state.ConnectionsList[fan['id_pressing_connection']].outlet_a;
                        fanObj.pressingConnection['outlet_b'] = (fan['suction_connection'] != 'special') ? (store.state.appMeasurementsList[fan['id_measurement']].outlet == 'rectangle' ? store.state.appMeasurementsList[fan['id_measurement']].outlet_b : 0) : store.state.ConnectionsList[fan['id_pressing_connection']].outlet_b;
                        fanObj.pressingConnection['norm'] = (fan['suction_connection'] != 'special') ? fanObj.pressingConnection['norm'] : store.state.ConnectionsList[fan['id_pressing_connection']].norm;
                        if(fan['suction_connection'] == 'special') fanObj.pressingConnection['image'] = store.state.ConnectionsList[fan['id_pressing_connection']].image;
                        fanObj.pressingConnection['title'] = 'pressing_connection'

                        // NVS-84 Tworzę obiekt przechowujący dane przyłącza
                        fan['connections'] = {
                            schema_title: "schema_connection",
                            title: "connections",
                            values: {
                                suction: fanObj.suctionConnection,
                                pressing: fanObj.pressingConnection
                            },
                            view: fan.suction_connection != 'none'
                        }
                    }

                    fanObj.params['version'] = fanInAtexex;
                    fanObj.params['standardVersion'] = fanStandardInAtex;
                    fanObj.model = data.extensionInfo.name_prefix + fanObj.model;

                    fanObj.data['network_frequency'] = frequencyTmp;
                    fanObj.data['characteristic_coefficient'] = (Constants.airPressure + measurementTmp.graphsObj.optimal[data.pressureTypeCapitalized + "Pressure"]) / Constants.airPressure;

                    let enginesFilteredByEngineRPM = data.firstStepFilteredEngines.filter((element) => {
                        return element.speed == engine_rpm
                    });

                    //Do nowej funkcji
                    let workPointAmountUnit = Number.parse(store.state.fourthStepParametersSelected['material_amount'].value) / 3.6 / Number.parse(measurementTmp.graphsObj.workPointResult.Performance.oryginal); //Poprawne

                    if (store.state.selectedFirstStepElement.default_minimum_material_density && store.state.selectedFirstStepElement.default_minimum_material_density == 1 && store.state.selectedFirstStepElement.default_minimum_material_density_value && parseFloat(store.state.selectedFirstStepElement.default_minimum_material_density_value) > workPointAmountUnit)
                        workPointAmountUnit = store.state.selectedFirstStepElement.default_minimum_material_density_value;

                    if (workPointAmountUnit > parseFloat(fan.max_density)) {
                        continueLooping = false;
// console.log("dsdsdsd");
//                         for (let grap in measurementTmp.graphsObj.graphs) {
//                             let plane =  measurementTmp.graphsObj.graphs[grap].graph;
//                             Events.remove(plane._svg);
//                             plane._svg = null;
//
//                             for(let i = plane._xs.length - 1; i >= 0; i--){
//                                 let axis = plane._xs[i];
//                                 Events.remove(axis._svg);
//                                 axis._svg = null;
//                                 plane.removeAxis(axis)
//                             }
//
//                             for(let i = plane._ys.length - 1; i >= 0; i--){
//                                 let axis = plane._ys[i];
//                                 Events.remove(axis._svg);
//                                 axis._svg = null;
//                                 plane.removeAxis(axis)
//                             }
//
//                             for (let point of measurementTmp.graphsObj.graphs[grap].points) {
//                                 measurementTmp.graphsObj.graphs[grap].removeAll();
//                             }
//                         }

                        measurementTmp = undefined;
                        // this.deepClearFunctions(measurementTmp, [measurementTmp.data, store, store.state.appMeasurementsList[fan['id_measurement']]]);
                        fanObj = undefined;

                        continue;
                    }

                    //Koniec nowej funkcji

                    let engine = this.findEngine(enginesFilteredByEngineRPM, fan, fanObj, measurementTmp, store, data.frequency); //Silnik musi być szukany po częstotliwości sieci

                    if (engine)//JEŚLI NIE DOBRAŁO SILNIKA, TO NIE DODAJEMY WENTYLATORA DO TABELI
                    {
                        let maximum_engine_power = this.calcMaximumEnginePower(engine_rpm, fanObj.params['installed_power'], engine["efficiency_3_4"]);
                        let engine_efficiency = engine["efficiency_3_4"];

                        fanObj.params['installed_power'] = fanObj.params['installed_power'];

                        fanObj.data['maximum_engine_power'] = maximum_engine_power;
                        fanObj.params['engine_efficiency'] = engine_efficiency;
                        fanObj.engine = engine;

                        if ((store.state.fourthStepParametersSelected.work_on_the_inverter.active && fanObjParamsManager.GetSelectedElementOfOption(store.state.fourthStepParametersSelected.work_on_the_inverter.options[0].elements) == "yes")
                            || store.state.selectedSecondStepElement.multiple_fans == 1) {
                            bestFanOfFrequency.push({fan: fanObj, measurement: measurementTmp, engine: engine, engine_efficiency: engine_efficiency,  maximum_engine_power: maximum_engine_power});
                        } else {
                            for (let param in store.state.fansTableData.params_table) {
                                if (store.state.fansTableData.params_table.hasOwnProperty(param)) {
                                    fanObjParamsManager.fillParam(fan, store, measurementTmp, param, fanObj, data.extensionInfo, number_of_fans);
                                    // if (!this.validateParam(fan, store, measurementTmp, param, fanObj, data.extensionInfo, number_of_fans)) {
                                    //     fanIsValid = false;
                                    //     break;
                                    // }
                                }
                            }
                            // NVS-44 Wzrost temperatury obliczamy niezależnie czy jest aktywny w tabeli wyników czy nie, ponieważ może być też aktywny w punkcie pracy, a wtedy jest potrzebny do ukrywania cen w tabeli wyników
                            fanObjParamsManager.fillParam(fan, store, measurementTmp, 'fan_temperature_increase', fanObj, data.extensionInfo, number_of_fans)

                            this.addFanToResultTable(fanObj, store);
                            // console.log("dsdsdsd");
                            // for (let grap in measurementTmp.graphsObj.graphs) {
                            //     let plane =  measurementTmp.graphsObj.graphs[grap].graph;
                            //     Events.remove(plane._svg);
                            //     plane._svg = null;
                            //
                            //     for(let i = plane._xs.length - 1; i >= 0; i--){
                            //         let axis = plane._xs[i];
                            //         Events.remove(axis._svg);
                            //         axis._svg = null;
                            //         plane.removeAxis(axis)
                            //     }
                            //
                            //     for(let i = plane._ys.length - 1; i >= 0; i--){
                            //         let axis = plane._ys[i];
                            //         Events.remove(axis._svg);
                            //         axis._svg = null;
                            //         plane.removeAxis(axis)
                            //     }
                            //
                            //     for (let point of measurementTmp.graphsObj.graphs[grap].points) {
                            //         measurementTmp.graphsObj.graphs[grap].removeAll();
                            //     }
                            // }
                            // this.deepClearFunctions(measurementTmp, [measurementTmp.data, store, store.state.appMeasurementsList[fan['id_measurement']]]);
                            engine = undefined;
                            fanObj = undefined;
                            measurementTmp = undefined;

                            continueLooping = false;
                        }
                    }
                }
            }

            incrementDoneFans();
            if (fans.length > indexOfFan + 1) {
                this.chechNextFan(fans, indexOfFan + 1, incrementDoneFans, store, data, timeoutsIDs);
            }
        }, 1);

        timeoutsIDs.push(timeoutID);
    }

    static compareAndFindBestFan(requestedPressureUnitValue, currentFan, actualMinDelta, pressureType) {
        if (!actualMinDelta || actualMinDelta > Math.abs(currentFan.measurement.graphsObj.workPointResult[pressureType + "Pressure"]._oryginal - requestedPressureUnitValue._oryginal)) {
            let newActualMinDelta = Math.abs(currentFan.measurement.graphsObj.workPointResult[pressureType + "Pressure"]._oryginal - requestedPressureUnitValue._oryginal);
            return {actualMinDelta: newActualMinDelta, fan: currentFan};
        } else {
            return null;
        }
    }

    static findEngine(firstStepFilteredEngines, fan, fanObj, measurementTmp, store, frequency) {
        // NVS-102 Dopiero na tym etapie można filtrować po temperaturze bo mamy już wentylator
        let desiredTemperature = fan.drive != 'direct' ? 20 : parseInt(fan.medium_temperature_to)
        firstStepFilteredEngines = firstStepFilteredEngines.filter((element) => {
            return this.enginesTemperatureFilter(desiredTemperature, element, store)
        });
        switch (fan.motor_power) {
            case "constant":
                return this.findConstantEngine(firstStepFilteredEngines, fan, fanObj, frequency);
                break;
            case "choice":
                return this.findChoiceEngine(firstStepFilteredEngines, fan, fanObj, measurementTmp, store, frequency);
                break;
            default:
                return null;
                break;
        }
    }

    static findConstantEngine(firstStepFilteredEngines, fan, fanObj, frequency) {
        for (let engine of firstStepFilteredEngines) {
            let enginePower = parseFloat(engine["power_" + frequency + "_hz"]);

            if (enginePower >= parseFloat(fan["power_" + frequency + "_hz"])) {
                fanObj.params['installed_power'] = enginePower;
                return engine;
            }
        }

        return null;
    }

    static findChoiceEngine(firstStepFilteredEngines, fan, fanObj, measurementTmp, store, frequency) {
        //Oblicza zagęszczenie materiału na pdostawie ilości materiału i uzyskanej wydajności
        let workPointAmountUnit = Number.parse(store.state.fourthStepParametersSelected['material_amount'].value) / 3.6 / Number.parse(measurementTmp.graphsObj.workPointResult.Performance.oryginal); //Poprawne

        if (store.state.selectedFirstStepElement.default_minimum_material_density && store.state.selectedFirstStepElement.default_minimum_material_density == 1 && store.state.selectedFirstStepElement.default_minimum_material_density_value && parseFloat(store.state.selectedFirstStepElement.default_minimum_material_density_value) > workPointAmountUnit)
            workPointAmountUnit = store.state.selectedFirstStepElement.default_minimum_material_density_value;

        if (workPointAmountUnit > parseFloat(fan.max_density))
            return null;

        let Pdobor = measurementTmp.graphsObj.workPointResult.PowerOnShaft.oryginal * ((measurementTmp.graphsObj.workPointResult.AirDensity + (workPointAmountUnit / 1000)) / measurementTmp.graphsObj.workPointResult.AirDensity);
        let engineIndex = 0;

        //Pierwszy przesiew silników
        for (let engine of firstStepFilteredEngines) {
            let engineRpm = parseFloat(engine.speed);
            let enginePower = parseFloat(engine["power_" + frequency + "_hz"]);
            let calculatedNsil = null;

            if (engineRpm == 3000) {
                calculatedNsil = this.calcNsil3000(Pdobor, 1);
            } else {
                calculatedNsil = this.calcNsil1500(Pdobor, 1);
            }

            if (calculatedNsil && enginePower >= calculatedNsil && enginePower >= fan.power_min) {
                firstStepFilteredEngines.splice(0, engineIndex);
                break;
            }

            engineIndex++;
        }
        engineIndex = 0;

        for (let engine of firstStepFilteredEngines) {
            let engineRpm = parseFloat(engine.speed);
            let enginePower = parseFloat(engine["power_" + frequency + "_hz"]);
            let calculatedNsil = null;

            // NVS-91 Obliczam czasy rozruchu
            fanObj.params.start_time = this.calcStartTime(engine, fan, fanObj, measurementTmp, frequency);
            fanObj.params.start_time.possible = this.startPossible(engine, fanObj, store);
            // NVS-91 Ustalam warunki do doboru
            const start_time_condition = store.state.appSettings.filter(elem => {return elem.setting == 'start_time_condition'})[0].value == "1";
            const moment_of_inertia = parseFloat(fan.moment_of_inertia) > 0;
            const work_on_the_inverter = store.state.fourthStepParametersSelected.work_on_the_inverter.active && fanObjParamsManager.GetSelectedElementOfOption(store.state.fourthStepParametersSelected.work_on_the_inverter.options[0].elements) == "yes";
            // NVS-91 Definiuję warunek
            const condition = moment_of_inertia && !(work_on_the_inverter && !start_time_condition) && !fanObj.params.start_time.possible

            if (engineRpm == 3000) {
                calculatedNsil = this.calcNsil3000(Pdobor, engine["efficiency_3_4"]);
            } else {
                calculatedNsil = this.calcNsil1500(Pdobor, engine["efficiency_3_4"]);
            }

            if (enginePower > fan.power_max) {//Silniki są posortowane wg mocy, wiec w tym momencie wiemy, ze reszta silnikow tez jest zbyt mocna
                return null;
            }

            if (calculatedNsil && enginePower >= calculatedNsil && !condition) {
                fanObj.params['installed_power'] = enginePower;
                return engine;
            }

            engineIndex++;
        }

        return null;
    }

    // NVS-91 Przenoszę obliczenia z engineStartTime.vue
    // Są potrzebne przy doborze silnika
    static calcStartTime(engine, fan, fanObj, measurementTmp, frequency) {
        const powerOnShaftMin = parseFloat(measurementTmp.graphsObj.fan.lines.PowerOnShaft.startPoint.y) / measurementTmp.graphsObj.numberOfFans;
        const ratedSpeed = this.round((measurementTmp.graphsObj.workPointResult.Frequency / 50) * parseFloat(fanObj.data.avg_nominal_speed), 0);

        let Mow = 9550 * (measurementTmp.graphsObj.workPointResult.PowerOnShaftWithMaterial.oryginal / measurementTmp.graphsObj.numberOfFans / ratedSpeed); //moment przy otwartej zasuwie
        let Mowz = 9550 * (powerOnShaftMin / ratedSpeed); //moment przy zamkniętej zasuwie
        let moment_delta = parseFloat(engine.torque_tn) * parseFloat(engine.torque_ts_tn); //moment DELTA
        let moment_y = moment_delta * 0.81 / 3; //moment Y
        let avg_mow = Mow * .4; //średni moment oporowy przy otwartej zasuwie
        let avg_mowz = Mowz * .4; //średni moment oporowy przy zamkniętej zasuwie
        let Wn = parseFloat(engine["speed_" + frequency + "_hz"]) * 3.14 / 30; //prędkość kątowa silnika
        let Ww = ratedSpeed * 3.14 / 30; //prędkość kątowa wirnika
        let J = parseFloat(engine.moment_of_inertia) + parseFloat(fan.moment_of_inertia) * Math.pow(Ww / Wn, 2); //moment zredukowany

        return {
            power_on_shaft_min: powerOnShaftMin,
            rated_speed: ratedSpeed,
            engine_speed: parseFloat(engine["speed_" + frequency + "_hz"]),
            rotor_moment_of_inertia: parseFloat(fan.moment_of_inertia),
            torque_tn: parseFloat(engine.torque_tn),
            moment_delta: moment_delta,
            moment_y: moment_y,
            avg_mow: avg_mow,
            avg_mowz: avg_mowz,
            moment_j: J,
            moment_open_valve: Mow,
            moment_closed_valve: Mowz,
            t_y: J * Wn / (moment_y - avg_mow), //czas rozruchu Y przy otwartej zasuwie
            t_yz: J * Wn / (moment_y - avg_mowz), //czas rozruchu Y przy zamkniętej zasuwie
            t_delta: J * Wn / (moment_delta - avg_mow), //czas rozruchu DELTA przy otwartej zasuwie
            t_deltaz: J * Wn / (moment_delta - avg_mowz) //czas rozruchu DELTA przy zamkniętej zasuwie
        }
    }

    // NVS-91 Metoda sprawdza czy start możliwy
    static startPossible(engine, fanObj, store) {
        const engineStartup = Object.values(store.state.EngineStartupList).find(item => {return item.mechanical_altitude == engine.mechanical_altitude && item.speed == engine.speed});

        const elements = []
        if(engineStartup) {
            engine.startup = engineStartup // zapisuję w silniku żeby nie szukać po raz drugi
            if(this.round(fanObj.params.start_time.t_delta, 1) <= parseFloat(engine.startup.dol_startup_time) && this.round(fanObj.params.start_time.t_deltaz, 1) <= parseFloat(engine.startup.dol_startup_time))  
                elements.push({ title: 'Δ', value: 'start_possible|direct_start'});
            else if(this.round(fanObj.params.start_time.t_delta, 1) > parseFloat(engine.startup.dol_startup_time) && this.round(fanObj.params.start_time.t_deltaz, 1) <= parseFloat(engine.startup.dol_startup_time))
                elements.push({ title: 'Δ', value: 'start_possible|direct_start|heavy_start'});

            if(this.round(fanObj.params.start_time.t_y, 1) <= parseFloat(engine.startup.dol_startup_time) && this.round(fanObj.params.start_time.t_yz, 1) <= parseFloat(engine.startup.dol_startup_time))
                elements.push({ title: 'Y', value: 'start_possible|direct_start'});
            else if(this.round(fanObj.params.start_time.t_y, 1) > parseFloat(engine.startup.dol_startup_time) && this.round(fanObj.params.start_time.t_yz, 1) <= parseFloat(engine.startup.dol_startup_time)) 
                elements.push({ title: 'Y', value: 'start_possible|direct_start|heavy_start'});

            if(this.round(fanObj.params.start_time.t_y, 1) <= parseFloat(engine.startup.y_delta_startup_time) && this.round(fanObj.params.start_time.t_yz, 1) <= parseFloat(engine.startup.y_delta_startup_time) && parseFloat(engine.startup.y_delta_startup_time) > 0)
                elements.push({ title: 'YΔ', value: 'start_possible'});
            else if(this.round(fanObj.params.start_time.t_y, 1) > parseFloat(engine.startup.y_delta_startup_time) && this.round(fanObj.params.start_time.t_yz, 1) <= parseFloat(engine.startup.y_delta_startup_time) && parseFloat(engine.startup.y_delta_startup_time) > 0)
                elements.push({ title: 'YΔ', value: 'start_possible|heavy_start'});

            if(elements.length > 0) return elements
        }
        return false
    }

    static round(num, dec) {
        return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
    }

    static calcNsil3000(Nwcz_p, Nsil) {
        let _Nsil = 1.07 * Nsil > 0.98 ? 0.98 : 1.07 * Nsil; // NVS-98

        return (Nwcz_p / _Nsil);
    }

    static calcNsil1500(Nwcz_p, Nsil) {
        let _Nsil = 1.03 * Nsil > 0.97 ? 0.97 : 1.03 * Nsil; // NVS-98

        return (Nwcz_p / _Nsil);
    }

    static calcMaximumEnginePower(engineRpm, installedPower, Nsil) {
        if (engineRpm == 3000) {
            return this.calcMaximumEnginePower3000(installedPower, Nsil);
        } else {
            return this.calcMaximumEnginePower1500(installedPower, Nsil);
        }
    }

    static popFansTable(store) {
        store.state.fansTableData.fans_table.splice(0, store.state.fansTableData.fans_table.length);


    }

    // static deepDelete(target, context) {
    //     // Assume global scope if none provided.
    //     context = context || window;
    //
    //     var targets = target.split('.');
    //
    //     if (targets.length > 1)
    //         this.deepDelete(targets.slice(1).join('.'), context[targets[0]]);
    //     else
    //         delete context[target];
    // }

    static deepDelete(element, skipElements = []){
        switch(typeof element){
            case "object":
                if(Array.isArray(element)){
                    for(let i = element.length; i >= 0; i--){
                        this.deepDelete(element[i], skipElements)
                        element.splice(i, 1);
                    }
                }else{
                    for(let key in element){
                        if(element.hasOwnProperty(key) && !skipElements.find(x=> x == element)){
                            if(element[key] instanceof HTMLElement || element[key] instanceof Node){
                                Events.remove(element[key]);
                            }else {
                                if (typeof element[key] != 'function') {
                                    console.log("<<<nie>>>funkcja" + key)
                                    this.deepDelete(element[key], skipElements);
                                } else {
                                    console.log("------------funkcja" + key)
                                }
                            }

                            delete element[key];
                        }
                    }
                }

                break;
        }

        // if(!skipElements.find(x=> x == element))
        //     element = null;
    }

    static deepClearFunctions(element, skipElements = []){
        switch(typeof element){
            case "object":
                if(Array.isArray(element)){
                    for(let i = element.length; i >= 0; i--){
                        this.deepClearFunctions(element[i], skipElements)
                        //element.splice(i, 1);
                    }
                }else{
                    for(let key in element){
                        if(element.hasOwnProperty(key) && !skipElements.find(x=> x == element)){
                            if(element[key] instanceof HTMLElement || element[key] instanceof Node){
                                Events.remove(element[key]);
                            }else {
                                if (typeof element[key] != 'function') {

                                    this.deepClearFunctions(element[key], skipElements);
                                } else {

                                    element[key] = () => {};
                                }
                            }

                        }
                    }
                }

                break;
        }
    }


    static calcMaximumEnginePower3000(installedPower, Nsil) {
        return installedPower * 1.07 * Nsil;
    }

    static calcMaximumEnginePower1500(installedPower, Nsil) {
        return installedPower * 1.03 * Nsil;
    }

    // NVS-57 Używamy metody zamiast statycznego przypisania klasy IE3
    static enginesFilter(current_type, current_phase, engine, store) {
        return engine['efficiency_class'] === this.getEfficiencyClassByPower(engine['power_designation'], store) &&
            engine["engine_type"] === 'Standardowy' &&
            engine["current_type"] == current_type &&
            engine['current_phase'] == current_phase
    }

    // NVS-102 Metoda do filtrowania silników po temperaturze
    static enginesTemperatureFilter(desiredTemperature, engine, store) {
        return engine["manufacturer"] === this.getDefaultManufacturerByTemperature(desiredTemperature, store) &&
            (parseFloat(engine['min_temperature']) <= desiredTemperature && desiredTemperature <= parseFloat(engine['max_temperature']));
    }

    static getFourthStepDefaultPropertyValue(store, property) {
        if (store.state.fourthStepParametersSelected[property].defaultValue !== undefined) {
            return store.state.fourthStepParametersSelected[property].defaultValue;
        } else {
            return store.state.fourthStepParametersSelected[property].value;
        }
    }

    static MakeMeasurement(store, id_measurement, frequency, pressureType, performance, performanceHour, getDefault = false) {
        const measurement = store.state.appMeasurementsList[id_measurement];

        if (measurement && measurement.hasOwnProperty("characteristic")) {
            let data = new Measurement();
            Object.assign(data, measurement);

            if (getDefault) {
                data.workPointAboveSea = this.getFourthStepDefaultPropertyValue(store, 'above_sea');
                data.workPointTemperature = this.getFourthStepDefaultPropertyValue(store, 'temperature');
                data.workPointPressure = this.getFourthStepDefaultPropertyValue(store, 'pressure');
            } else {
                data.workPointAboveSea = store.state.fourthStepParametersSelected.above_sea.value;
                data.workPointTemperature = store.state.fourthStepParametersSelected.temperature.value;
                data.workPointPressure = store.state.fourthStepParametersSelected.pressure.value;
            }

            data.workPointPerformance = performance;
            data.workPointPerformanceHour = performanceHour;

            data.workPointPressureType = pressureType;

            let measurementTmp = Object.create(measurementsAbstract);

            Object.assign(measurementTmp, {
                init(store, data) {
                    this.data = data;
                    this.store = store;
                    this.graphsObj = new fanGraphs(null, data, null, null, false);
                },
                calc() {
                    this.refreshAirDensity();
                    this.refreshAmountUnit();

                    this.data.workPointFrequency = frequency;
                    this.data.workPointPerformance = performance;
                    this.data.workPointPerformanceHour = performanceHour;

                    this.data.calcArea();
                    this.data.limitValues();

                    this.workPointAirDensityTotal();

                    this.graphsObj.createInitialLines();
                    this.graphsObj.refreshLines();
                    this.graphsObj.drawRequestedLine2();

                    for (let graph of Object.values(this.graphsObj.graphs)) {//lecimy po pojedynczych wykresach
                        graph.minX = this.graphsObj.fanRecalced.min;
                        graph.maxX = this.graphsObj.fanRecalced.max;
                    }

                    this.graphsObj.calcOptimalPoint();
                },
            });

            measurementTmp.init(store, data);
            measurementTmp.calc();

            return measurementTmp;
        }

        return null;
    }

    static addFanToResultTable(fan, store) {
        if (!fan.data['number_of_fans'] || store.state.selectedSecondStepElement.multiple_fans == 0)
            fan.data['number_of_fans'] = 1;

        if (!fan.params['number_of_fans'] || store.state.selectedSecondStepElement.multiple_fans == 0)
            fan.params['number_of_fans'] = 1;

        fan.initial_params = {...fan.params};
        store.state.fansTableData.fans_table.push(fan);
    }

    static addParamRangeFrom(store, paramValue, requestedValue, paramName) {
        if (store.state.fansTableData.params_table[paramName]) {
            if (store.state.fansTableData.params_table[paramName].type == "from_to")
                return parseFloat(store.state.fansTableData.params_table[paramName].range_from);

            if (store.state.fansTableData.params_table[paramName].type == "plus_minus")
                return parseFloat(requestedValue) - parseFloat(store.state.fansTableData.params_table[paramName].range_from);
        }

        return paramValue;
    }

    static addParamRangeTo(store, paramValue, requestedValue, paramName) {
        if (store.state.fansTableData.params_table[paramName]) {
            if (store.state.fansTableData.params_table[paramName].type == "from_to")
                return parseFloat(store.state.fansTableData.params_table[paramName].range_to);

            if (store.state.fansTableData.params_table[paramName].type == "plus_minus")
                return parseFloat(requestedValue) + parseFloat(store.state.fansTableData.params_table[paramName].range_to);
        }

        return paramValue;
    }


    static getCalculatedValueOfProperty(property) {
        return parseFloat((property._oryginal - property._unit.a0 / property._unit.a0d) * property._unit.a1d / property._unit.a1).toFixed(property._unit.decimal_places)
    }

    static validate_electricity(fan, store) {
        if (store.state.fourthStepParametersSelected.electricity.options.current_phase.elements["Phase" + fan.current_phase] &&
            store.state.fourthStepParametersSelected.electricity.options.current_phase.elements["Phase" + fan.current_phase].active &&
            store.state.fourthStepParametersSelected.electricity.options.current_type.elements[fan.current_type] &&
            store.state.fourthStepParametersSelected.electricity.options.current_type.elements[fan.current_type].active)
            return true;
        else
            return false;
    }

    static validateFilterLocation(filter, fan) {
        if (filter) {
            switch (filter) {
                case 'lying':
                    if (fan.filter_location == "inside")
                        return true;
                    break;
                case 'standing':
                    if (fan.filter_location == "outside")
                        return true;
                    break;
                default:
                    return false;
            }

            return false;
        } else {
            return true;
        }
    }

    static getFanPositionFilter(store) {
        if (store.state.fourthStepParameters.fan_position.active)
            return fanObjParamsManager.GetSelectedElementOfOption(store.state.fourthStepParameters.fan_position.options[0].elements);
        else
            return null;
    }

    static getExtensionInfo(store) {
        let ifExtensions = false;
        let extensionWhere = "";
        let extensionNumber = "";

        for (let optionId in store.state.fourthStepParametersSelected.ex.options) {
            let option = store.state.fourthStepParametersSelected.ex.options[optionId];
            let selectedValue = null;

            if (option.elements)
                selectedValue = fanObjParamsManager.GetSelectedElementOfOption(option.elements);

            if (option.type == "radio") {
                if (selectedValue == "yes")
                    ifExtensions = true;
            } else if (option.value && option.value == "where") {
                extensionWhere = fanObjParamsManager.GetSelectedElementOfOption(option.elements);
            } else if (option.value && option.value == "ex_number") {
                extensionNumber = fanObjParamsManager.GetSelectedElementOfOption(option.elements);
            }
        }

        if (extensionWhere == "inside_and_outside")
            extensionWhere = "both";

        if (!ifExtensions)
            return store.state.atexesList.find(x => x['zone_inside'] == "" && x['zone_outside'] == "" && x.type == "");
        else {       
            // NVS-110
            const both = extensionNumber.split(' + ')
            if (extensionWhere != 'both')
                return store.state.atexesList.find(x => x['zone_' + extensionWhere] == extensionNumber && x.type == extensionWhere)
            else
                return store.state.atexesList.find(x => x['zone_inside'] == (both.length > 1 ? both[0] : extensionNumber) && x['zone_outside'] == (both.length > 1 ? both[1] : extensionNumber) && x.type == extensionWhere)
        }
    }

    static range(start, end) {
        return Array(end - start + 1).fill().map((_, idx) => start + idx)
    }

}

export {Calculator}